import component from './SortingConstructor.vue'
export default component
